// qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/ConnectorDefinitionPickerModal.jsx

import React, { useState, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import { FaTimes, FaSearch, FaCheckCircle, FaWrench, FaExclamationTriangle } from "react-icons/fa";
import styles from "./PostTriggerModal.module.css";

const BUCKET_META = {
  ready: { label: "Ready", hint: "Click to attach", icon: FaCheckCircle, color: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0" },
  needsMapping: { label: "Needs mapping", hint: "Click to map fields", icon: FaWrench, color: "#d97706", bg: "#fffbeb", border: "#fde68a" },
  blocked: { label: "Missing data", hint: "Needs custom override", icon: FaExclamationTriangle, color: "#dc2626", bg: "#fef2f2", border: "#fecaca" },
};

function readBuckets(buckets) {
  const safe = buckets || {};
  return {
    ready: safe.ready || [],
    needsMapping: safe.needsMapping || safe["needs-mapping"] || [],
    blocked: safe.blocked || [],
  };
}

const ConnectorDefinitionPickerModal = ({ isOpen, onClose, onPick, buckets }) => {
  const [filter, setFilter] = useState("");
  useEffect(() => { if (isOpen) setFilter(""); }, [isOpen]);

  const filtered = useMemo(() => {
    const b = readBuckets(buckets);
    const f = filter.toLowerCase();
    const m = (arr) => arr.filter(e => !f || `${e.definition.name} ${e.definition.operation_name}`.toLowerCase().includes(f));
    return {
      ready: m(b.ready), needsMapping: m(b.needsMapping), blocked: m(b.blocked),
      total: b.ready.length + b.needsMapping.length + b.blocked.length
    };
  }, [buckets, filter]);

  if (!isOpen || typeof document === "undefined") return null;

  const renderBucket = (key) => {
    const entries = filtered[key];
    if (entries.length === 0) return null;
    const meta = BUCKET_META[key];
    return (
      <div key={key} style={{ marginBottom: 16, padding: 12, background: meta.bg, border: `1px solid ${meta.border}`, borderRadius: 8 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
          <meta.icon size={14} style={{ color: meta.color }} />
          <span style={{ fontSize: 12, fontWeight: 700, color: meta.color, textTransform: "uppercase" }}>{meta.label}</span>
        </div>
        <div className={styles.opGrid}>
          {entries.map((entry) => (
            <button key={entry.definition.definition_id} className={styles.opCard} onClick={() => onPick(entry)} style={{ borderColor: key === "blocked" ? meta.border : undefined }}>
              <div className={styles.opCardName}>{entry.definition.name}</div>
              <div className={styles.opCardKey}><code>{entry.definition.operation_name}</code></div>
              {key !== "ready" && <div style={{ marginTop: 6, fontSize: 11, color: meta.color }}>{entry.classification.reason}</div>}
            </button>
          ))}
        </div>
      </div>
    );
  };

  return createPortal(
    <div className={styles.overlay} onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()} style={{ background: "white", borderRadius: 12, width: "100%", maxWidth: 720 }}>
        <div className={styles.header}>
          <h3 className={styles.title}>Attach a connector action</h3>
          <button onClick={onClose} className={styles.closeBtn}><FaTimes size={14} /></button>
        </div>
        <div className={styles.body}>
          <div className={styles.searchRow}>
            <FaSearch size={12} className={styles.searchIcon} />
            <input type="text" className={styles.searchInput} placeholder="Filter actions..." value={filter} onChange={(e) => setFilter(e.target.value)} />
          </div>
          {filtered.total === 0 && <div className={styles.emptyBlock}>No actions found.</div>}
          {renderBucket("ready")}
          {renderBucket("needsMapping")}
          {renderBucket("blocked")}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConnectorDefinitionPickerModal;